"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API_TO_MOMENT_MAP = void 0;

var Moments = _interopRequireWildcard(require("../../../Moment"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var API_TO_MOMENT_MAP = {
  'award': Moments.AwardMoment,
  'audio': Moments.AudioMoment,
  'education': Moments.EducationMoment,
  'employer': Moments.EmployerMoment,
  'iframe': Moments.IFrameMoment,
  'image': Moments.ImageMoment,
  'library': Moments.LibraryMoment,
  'map': Moments.MapMoment,
  'membership': Moments.MembershipMoment,
  'mirador': Moments.MiradorMoment,
  'named_after': Moments.NamedAfterMoment,
  'pdf': Moments.PDFMoment,
  'people': Moments.PeopleMoment,
  'reference': Moments.ReferenceMoment,
  'timeline': Moments.TimelineMoment,
  'video': Moments.VideoMoment,
  'wikidata': Moments.WikidataMoment,
  'wikipedia': Moments.WikipediaMoment,
  'youtube': Moments.YouTubeMoment
};
exports.API_TO_MOMENT_MAP = API_TO_MOMENT_MAP;